import React, {} from "react"
import "@styles/react/home.scss"
import {Helmet} from "react-helmet"
import {useTranslation} from "react-i18next"
import {Link} from "react-router-dom"
import {Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap"
import {trans} from "../../configs/i18n"

const HomePageView = () => {
  const { i18n } = useTranslation()

  // ** Vars
  const langObj = {
    pl : 'Polski',
    en: 'English',
    es: 'Español',
    sr: 'Serbian'
  }

  const handleLangUpdate = (e, lang) => {
    e.preventDefault()
    i18n.changeLanguage(lang)
  }
  const logo = require(`@src/assets/images/logo/Betfolio_logo_1.png`)
  return (
    <>
    <Helmet htmlAttributes={{ lang: i18n.language }}>
      <title>Betfolio | {trans('title_home')}</title>
      <meta name="description" content={trans('description_feed')} />
      <meta name="keywords" content={trans('keywords_feed')} />

    </Helmet>
    <div className={'d-flex h-100 text-center'}>
    <div className="cover-container d-flex w-100 h-100 p-1 mx-auto flex-column">
      <main className="betfolio-content my-auto">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <a href="#">
              <img width={170} src={logo} className={'homepage'} alt="logo" />
            </a>
          </div>
          <div className="betfolio-right-content col-lg-6">
            <div className={'d-flex flex-column mb-3'}>
              <h1 className={'homepage'} style={{color: '#ffffff', marginBottom: 0}}>{trans('home.header.title')}</h1>
              <h1 className={'homepage'} style={{color: '#ffffff', marginBottom: 0}}>{trans('home.subheader')}</h1>
            </div>
            <p className={'homepage'}>{trans('home.joinToUS')}</p>
            <div className={'d-flex flex-column buttons-container pt-1'}>
            <Link className="d-inline px-0" to={'/register'}>
              <Button color={'primary'} className={'w-100'}>
                {trans('login.button.register')}
              </Button>
            </Link>
              <div className={'pt-2'}>
            <Link className="d-inline px-0" to={'/login'}>
              <Button color="light" className={'w-100'}>
              {trans('login.button.login')}
              </Button>
            </Link>
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className={'homepage'}>
        <ul className="betfolio-menu">
          <li><a href="https://blog.betfolio.io" target={'_blank'}>{trans('home.footer.knowledge')}</a></li>
          <li><a href="/login">{trans('login.button.login')}</a></li>
          <li><a href="/register">{trans('login.button.register')}</a></li>
          <li><a href="/rules">{trans('home.footer.rules')}</a></li>
          <li><a href="mailto:kontakt@betfolio.io">kontakt@betfolio.io</a></li>
        </ul>

        <div className={'d-flex justify-content-center home-lang-container'}>
          <UncontrolledDropdown setActiveFromChild>
            <DropdownToggle
              caret
              className="home-lang-dropdown"
              tag="a"
            >
              {
                langObj[i18n.language] !== undefined ? langObj[i18n.language] : i18n.language === 'pl-PL' ? 'Polski' : i18n.language === 'es-ES' ? 'Español' : 'English'
              }
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                href="#"
                tag="a"
                onClick={e => handleLangUpdate(e, 'en')}
              >
                Angielski
              </DropdownItem>
              <DropdownItem
                href="#"
                tag="a"
                onClick={e => handleLangUpdate(e, 'pl')}
              >
                Polski
              </DropdownItem>
              <DropdownItem
                href="#"
                tag="a"
                onClick={e => handleLangUpdate(e, 'es')}
              >
                Español
              </DropdownItem>
              <DropdownItem
                href="#"
                tag="a"
                onClick={e => handleLangUpdate(e, 'sr')}
              >
                Serbian
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          <div className={'pl-1 pr-1'}>   </div>
          <p style={{marginLeft: '16px'}}>&copy; Betfolio 2024</p>
          </div>
      </footer>

    </div>
    </div>
    </>
  )
}

export default HomePageView